import React, { PropsWithChildren, ReactElement } from "react";
import { InfoBlockProps } from "./InfoBlock.types";
import { SmallBody } from "src/components/Text";
import { Conditional } from "src/components/Conditional";

/**
 * Displays a block of information.
 * 
 * @param param0 The properties of the InfoBlock component.
 * @returns The element to render.
 */
function InfoBlock({
    children,
    heading
}: PropsWithChildren<InfoBlockProps>): ReactElement {
    return (
        <section className="InfoBlock">
            <Conditional condition={!!heading}>
                <SmallBody
                    className="InfoBlock-heading"
                    color="contentDark"
                    weight="medium"
                >
                    {heading}
                </SmallBody>
            </Conditional>
            <div className="InfoBlock-content">
                {children}
            </div>
        </section>
    );
}

export default InfoBlock;